import { twMerge } from 'tailwind-merge';

import { PostsViewerSection } from '../PostsViewerSection/PostsViewerSection';
import { CatchDetails } from './CatchDetails/CatchDetails';
import { useCatchDetails } from './CatchDetails/useCatchDetails';

interface PostDetailsViewProps {
  currentPostId: string | undefined;
  className?: string;
  onBackButtonClick: () => void;
  scrollSelector?: string;
  hasCatch?: boolean;
}

export const PostDetailsView = ({
  currentPostId,
  className,
  onBackButtonClick: handleBackButtonClick,
  scrollSelector,
  hasCatch = false,
}: PostDetailsViewProps) => {
  const { catchDetails, isLoading } = useCatchDetails(currentPostId);

  // todo for posts without catch details maybe show gear here

  return (
    <PostsViewerSection
      className={twMerge('flex flex-col', className)}
      isLoading={isLoading}
      navigationLocationName="Catch details"
      onBackButtonClick={handleBackButtonClick}
    >
      {hasCatch && <CatchDetails catchDetails={catchDetails} scrollSelector={scrollSelector} />}
    </PostsViewerSection>
  );
};
